import LabelledItem, {
  LabelledItemProps,
} from '../../atoms/LabelledItem/LabelledItem';

export interface LabelledItemShape {
  label: string;
  value?: string | number | JSX.Element;
  key?: string;
  className?: string;
}
export interface LabelledItemListProps {
  items: LabelledItemShape[];
  itemProps?: Omit<LabelledItemProps, 'label' | 'value'>;
  listWrapperClasses?: string;
}

export function LabelledItemList({
  items,
  itemProps,
  listWrapperClasses = 'font-nunito grid grid-cols-2 md:grid-cols-5 gap-y-6 gap-x-4',
}: LabelledItemListProps) {
  const { wrapperClasses, labelClasses, valueClasses } = itemProps || {};

  return (
    <div className={listWrapperClasses}>
      {items.map((item, index) => (
        <LabelledItem
          key={(item.key || item.label) + index}
          label={item.label}
          value={item.value}
          wrapperClasses={wrapperClasses || item.className}
          labelClasses={labelClasses}
          valueClasses={valueClasses}
        />
      ))}
    </div>
  );
}
export default LabelledItemList;
